// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"ee01764e","684":"f4ee2e4a","785":"c6191ef4","842":"e15b8e84","930":"dc142ba9"}[chunkId] + ".chunk.css";
};